function workOrderPropertyKey(order) {
  const id = Number(order && order.propertyId);
  if (Number.isFinite(id) && id > 0) return `id:${id}`;
  const address = String((order && order.property_address) || '')
    .replace(/<[^>]+>/g, '')
    .trim()
    .toLowerCase();
  return address ? `addr:${address}` : '';
}

function sameWorkOrderProperty(a, b) {
  const left = workOrderPropertyKey(a);
  const right = workOrderPropertyKey(b);
  return !!left && left === right;
}

function isOpenWorkOrder(order) {
  if (!order) return false;
  if (order.deleted === 1 || order.deleted === true || order.deleted === '1') {
    return false;
  }
  return !order.completedOn;
}

function workOrderMergeCandidates(orders, primary) {
  if (!primary || primary.id == null) return [];
  return (orders || [])
    .filter((order) => {
      if (!order || String(order.id) === String(primary.id)) return false;
      if (!isOpenWorkOrder(order)) return false;
      return sameWorkOrderProperty(order, primary);
    })
    .slice()
    .sort((a, b) => Number(a.id) - Number(b.id));
}

function filterWorkOrderMergeCandidates(orders, query) {
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return orders || [];
  return (orders || []).filter((order) => {
    const haystack = [
      order && order.id,
      order && order.name,
      order && order.property_address,
      order && order.problem_description,
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(needle);
  });
}

/** Append each source description under a **from #id:** line. */
function mergedProblemDescription(primaryText, sources) {
  let text = String(primaryText || '').replace(/\s+$/, '');
  (sources || []).forEach((source) => {
    if (!source || source.id == null || source.id === '') return;
    const marker = `**from #${source.id}:**`;
    if (text.includes(marker)) return;
    const description = String(source.problem_description || '').trim();
    const block = `${marker}\n${description}`;
    text = text ? `${text}\n\n${block}` : block;
  });
  return text;
}

/** Note stored on a work order that was closed into another. */
function mergeCloseNote(existingNote, primaryId) {
  const line = `merged with work order #${primaryId}`;
  const current = String(existingNote || '').trim();
  if (!current) return line;
  if (current.toLowerCase().includes(line.toLowerCase())) return current;
  return `${current}\n${line}`;
}

module.exports = {
  sameWorkOrderProperty,
  isOpenWorkOrder,
  workOrderMergeCandidates,
  filterWorkOrderMergeCandidates,
  mergedProblemDescription,
  mergeCloseNote,
};
